import {
  setHasPhoto,
  setLoading,
  setPhotoInfo,
} from "../../store/userStore.js";
import { graphConfig } from "./AuthConfig.jsx";

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export function callMsGraph(accessToken, callback) {
  return (dispatch) => {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    dispatch(setLoading(true));

    fetch(graphConfig.graphPhotoEndpoint, options)
      .then((response) => {
        if (response && response.status > 300) {
          dispatch(setLoading(false));
        } else {
          return response.blob();
        }
      })
      .then((response) => {
        dispatch(setLoading(false));
        dispatch(setHasPhoto(true));
        callback(URL.createObjectURL(response));
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          dispatch(setLoading(false));
        }
        dispatch(setHasPhoto(false));
        callback(null);
        console.log(error);
      });
  };
}
